<template>
  <b-container fluid class="theme-yellow">
    <div class="page-header">
      <Navbar text="Mixed Reality Viewer" />
    </div>

    <section>
      <h2>What is Harpra Mixed Reality Viewer?</h2>

      <p>
        Harpra Mixed Reality Viewer is the core application of the Harpra Platform, which is designed to maximize the value of
        your company's 3D Content by allowing you to display and interact with these models in Mixed Reality.
      </p>

      <h2>Get Started</h2>

      <b-button variant="primary" :to="{ name: 'Models', query: { add: true } }" class="mr-3">
        Upload Models
      </b-button>
    </section>

    <section>
      <h2>Mixed Reality Viewer apps</h2>

      <p>
        To fully utilize Harpra Platform get one of the apps to display the content.
      </p>

      <b-card-group deck class="mobile-apps-deck">
        <b-card>
          <qrcode-vue class="app-qr-code" :value="appleAppStoreLink" size="100%" level="L" render-as="svg" />
          <b-card-body>
            <a :href="appleAppStoreLink">
              <img class="app-badge" :src="require(`@/assets/images/apple-appstore-badge.png`)">
            </a>
          </b-card-body>

          <template #footer>
            <small class="text-muted">Harpra for iOS</small>
          </template>
        </b-card>
        <b-card>
          <qrcode-vue class="app-qr-code" :value="googlePlayStoreLink" size="100%" level="L" render-as="svg" />
          <b-card-body>
            <a :href="googlePlayStoreLink">
              <img class="app-badge" :src="require(`@/assets/images/google-play-badge.png`)">
            </a>
          </b-card-body>

          <template #footer>
            <small>Harpra for Android</small>
          </template>
        </b-card>
      </b-card-group>
    </section>

    <section>
      <h2>Resources</h2>

      <div class="resources">
        <b-embed
          type="iframe"
          aspect="16by9"
          src="https://www.youtube.com/embed/ij_B2f5roGc"
          allowfullscreen
        ></b-embed>

        <b-embed
          type="iframe"
          aspect="16by9"
          src="https://www.youtube.com/embed/bG55vNDzM1U"
          allowfullscreen
        ></b-embed>
      </div>
    </section>
  </b-container>
</template>

<script>
import Navbar from "@/components/Navigation/Navbar";
import * as harpraApi from "@/services/api.service";
import * as routerUtils from "@/utils/router-utils";
import QrcodeVue from 'qrcode.vue'

export default {
  name: "Viewer",
  data() {
    return {
      subscriptionActive: false,
      googlePlayStoreLink: "https://play.google.com/store/apps/details?id=com.harvinar.harpra",
      appleAppStoreLink: "https://apps.apple.com/pl/app/harpra/id1525570993"
    };
  },
  components: {
    Navbar,
    QrcodeVue
  },
  computed: {},
  methods: {},
  created() {
    this.$AuthService.getAccessToken(
      async () => {
        try {
          let subscriptionInfo = await harpraApi.getSubscriptionInfo(
            this.$AuthService.token.accessToken
          );

          this.subscriptionActive = subscriptionInfo.isActive;
        } catch (error) {
          console.log("[WARN ] Couldn't get subscription info.");

          this.subscriptionActive = false;
        }

        if (!this.subscriptionActive) {
          routerUtils.routeToAccount(this);
        }
      },
      () => {
        console.log("[ERROR] Couldn't get access token.");
      }
    );
  },
  mounted() {},
};
</script>
